export default __webpack_public_path__ + "static/media/404.43bce9fc.jpg";